module.exports = __webpack_public_path__ + "static/media/whatsapp.2b5545f8.png";